<template>
    <div class="text-center my-5 text-danger font-weight-bolder">
        {{$t('notification.incorrect_domain')}}
    </div>
</template>

<script>
export default {
    name: "AppContentError",
    components: {},
    props: {},
    data() {
        return {}
    },
    mounted() {
    },
    methods: {},
    computed: {},
    filters: {},
    watch: {}
}
</script>

<style scoped>

</style>
